export const getADStatementMessages = (adStatementMessages) => {
    return {
        BANK_NAME: getADStatementMessageBodyFromPosition(adStatementMessages, "AdvanceDisbursementsStatementBankName"),
        BANK_ACCOUNT_NAME: getADStatementMessageBodyFromPosition(adStatementMessages, "AdvanceDisbursementsStatementAccountName"),
        BANK_SORT_CODE: getADStatementMessageBodyFromPosition(adStatementMessages, "AdvanceDisbursementsStatementSortCode"),
        BACK_ACCOUNT_NUMBER: getADStatementMessageBodyFromPosition(adStatementMessages, "AdvanceDisbursementsStatementAccountNumber"),
        COMMENTS_OR_SPECIAL_INSTRUCTIONS: getADStatementMessageBodyFromPosition(adStatementMessages, "AdvanceDisbursementsStatementCommentsOrSpecialInstructions"),
        BANK_MESSAGE: getADStatementMessageBodyFromPosition(adStatementMessages, "AdvanceDisbursementsStatementBankMessage")
    }
};

export const getADStatementMessageBodyFromPosition = (adStatementMessages, position) => {
    const found = adStatementMessages.find(i => i.position === position);
    if(found){
        return found.body;
    }

    return "";
};